import { ValidateEventFxn } from 'common.types'
import {
  MailInBallotErrorScreen,
  MailInBallotSuccessScreen,
} from '../components'
import { globalStore } from '../../../../stores/GlobalStore'

/**
 *
 * @param step
 * @param apiResponse
 * @param setReplacementContent
 * @returns {boolean} If `true`, then form continues to next step
 */
const validateMailInBallotEvent: ValidateEventFxn = (
  step,
  apiResponse,
  setReplacementContent,
  setState,
  type,
) => {
  const { serverResponse } = apiResponse
  const setSuccessFlag = (flag: boolean) => {
    const globalState = globalStore?.state
    globalStore.setState({
      ...globalState,
      formEvents: {
        ...(globalState.formEvents ?? {}),
        mailInBallotSubmitSuccess: flag,
      },
    })
  }
  if (type === 'submit') {
    if (
      serverResponse?.data?.data?.response.errors.length < 1 ||
      serverResponse?.data?.data?.response.errors[0].length < 1 ||
      Object.values(serverResponse?.data?.data?.response.errors[0])?.[0] === ''
    ) {
      setReplacementContent(<MailInBallotSuccessScreen />)
      setSuccessFlag(true)
      return true
    }
    setReplacementContent(<MailInBallotErrorScreen />)
    setSuccessFlag(false)
    return false
  }
  return true
}
export default validateMailInBallotEvent
